/*
 * @Author: lishuai lish@zhiding.com.cn
 * @Date: 2022-11-10 18:17:34
 * @LastEditors: lishuai lish@zhiding.com.cn
 * @LastEditTime: 2024-09-11 18:27:14
 * @FilePath: \sst-sjt-online-fe\src\main.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store"

// rem 布局
import 'amfe-flexible'

// 导入样式文件
// icon-park 的样式文件
import '@icon-park/vue/styles/index.css'

// 全量引入 vant 框架，作为主框架，直接使用全量组件，不再每个单 vue 文件单独引入组件
import Vant from 'vant';
import 'vant/lib/index.css';

// 导入轮播图的库
// import 'swiper/css/swiper.css'
import 'swiper/swiper-bundle.css'

// 导入 font-awesome css 库，用于sst 选择正确的动画
import "font-awesome/css/font-awesome.min.css"


import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)

Vue.use(Vant);


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
